<template>
  <div>
    <md-dialog
      v-model="activeVisible"
      :closable="false"
      :btns="btns"
    >
      {{ $t('flash_pay_service') }}
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
export default {
  name: 'ActivedDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      btns: [
        {
          text: this.$t('cancel'),
          handler: this.onBasicCancel
        },
        {
          text: this.$t('activate'),
          handler: this.onBasicConfirm
        }
      ]
    }
  },
  computed: {
    activeVisible: {
      get () {
        return this.$store.state.activeVisible
      },
      set () {}
    }
  },
  methods: {
    onBasicConfirm () {
      this.$store.commit('change_activeVisible', false)
      this.$store.commit('change_agreementVisible', true)
    },
    onBasicCancel () {
      this.$store.commit('change_activeVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: center;
  line-height: 48px;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
